/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  document.addEventListener("theme:cart:change", (event) => {
    const items = document.querySelectorAll(
      "cart-drawer .drawer__items .cart__item"
    );
    let total_savings = 0;
    for (let i = 0; i < items.length; i++) {
      const num = items[i].querySelector("input.cart__quantity-field").value ?? 1;
      const prices = items[i].querySelector(".cart__price");

      try {
        const price = Number(
          prices.children[0].innerHTML.replace(/[^0-9\.-]+/g, "")
        );
        const price_show = Number(
          prices.children[1].innerHTML.replace(/[^0-9\.-]+/g, "")
        );

        total_savings += (num * Math.abs(price_show - price));
      } catch (e) {
        console.error("could not calculate savings", e);
      }
    }

    const banner = document.getElementById("cart_price_discount_banner");
    if (total_savings) {
      banner.innerHTML = banner.innerHTML.replace(
        /[0-9,\.]+/g,
        new Intl.NumberFormat("it-IT", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(total_savings / 100)
      );
    } else {
      banner.style.display = "none";
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();